export const createLocalDate = (date = new Date()) => {
    let targetDate;
    if (date instanceof Date) {
        targetDate = date;
    }
    else {
        targetDate = new Date(date);
    }
    return new Date(targetDate.getFullYear(), targetDate.getMonth(), targetDate.getDate(), 0, 0, 0, 0);
};
export const parseLocalDate = (dateString) => {
    if (!dateString)
        return null;
    if (dateString.includes('T')) {
        const isoDate = new Date(dateString);
        return new Date(isoDate.getUTCFullYear(), isoDate.getUTCMonth(), isoDate.getUTCDate(), 0, 0, 0, 0);
    }
    const date = new Date(dateString);
    return createLocalDate(date);
};
export const dateToISOString = (date) => {
    const utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), 0, 0, 0, 0));
    return utcDate.toISOString();
};
export const isValidDateFormat = (dateString) => {
    const dateFormatRegex = /^\d{1,2}\/\d{1,2}\/\d{4}$/;
    return dateFormatRegex.test(dateString);
};
export const minDate = new Date(1970, 0, 1, 0, 0, 0, 0); // Jan 01 1970
//# sourceMappingURL=index.js.map